import React from "react";
import './ThankYou.css'

const ThankYou = () => {
  return (
    <div className="container">
      <header className="header">
        <h1 className="logo-thank-you">Divori: Your AI Divorce Consultant</h1>
      </header>
      <main className="main">
        <div className="icon-wrapper">
          <span className="icon">✔</span>
        </div>
        <h2 className="heading">Thank You!</h2>
        <p className="text">
          We are sending your personalized divorce guide to your inbox. 
          It’s easy to access and includes everything you need.
        </p>
        <p className="text">
          It may take a few minutes.
        </p>
        <p className="text">
          If you don’t receive it within 1 hour, please contact us at{" "}
          <a href="mailto:divori.solutions@gmail.com" className="link">
            divori.solutions@gmail.com
          </a>.
        </p>
        <a href="/" className="button">
          Go back to Home
        </a>
      </main>
    </div>
  );
};

export default ThankYou;